import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import QuestionText from '../components/QuestionText';
import FormControl from '@material-ui/core/FormControl';
import Button from '../../../components/Button.js';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles(theme => ({
  formControl: {
    width: '100%',
    margin: 0,
    backgroundColor: theme.palette.common.white,
  },
  button: {
    padding: '1.5rem 0',
    display: 'flex',
    justifyContent: 'center',
  },
}));

const OtherInformationQuestion = ({data, handleAnswer}) => {
  const classes = useStyles();
  const [content, setContent] = React.useState(data.other);
  const handleSubmit = () => {
    handleAnswer('other', content);
  };
  return (
    <React.Fragment>
      <QuestionText>
        Please tell us anything else that is important to you (optional).
      </QuestionText>
      <FormControl className={classes.formControl}>
        <TextField
          placeholder="(Skip this step if there's nothing else we need to know)"
          variant="outlined"
          multiline
          rows="5"
          value={content}
          onChange={e => setContent(e.target.value)}
        />
      </FormControl>
      <div className={classes.button}>
        <Button
          onClick={handleSubmit}
          label="Next"
          pointer="right"
          variant="contained"
        />
      </div>
    </React.Fragment>
  );
};

OtherInformationQuestion.propTypes = {
  data: PropTypes.object.isRequired,
  handleAnswer: PropTypes.func.isRequired,
};

export default OtherInformationQuestion;
